<template>
  <div class="invoice-list">
    <div class="invoice-list__title">
      <div class="breadcrumb">
        <span class="title">我的订阅</span>
        >
        <span class="gray">开发票</span>
      </div>
      <span class="main-text back" @click="back">返回</span>
      <div>
        已选订单金额：
        <span class="main-color">{{ amount }}</span
        >元
        <span class="main-text" style="margin: 0 20px;" @click="toggleSelection">全选</span>
        <div class="btn" @click="submit">提交开票</div>
        <span class="main-text back" @click="reviewRules">查看开票规则</span>
      </div>
    </div>
    <div class="invoice-list__content">
      <List :totalCount="totalCount" @flipPage="flipPage" :currentPage="currentPageNo" :pageSize="10">
        <template v-slot:listContent>
          <div class="invoice-list-wrapper">
            <el-table ref="multipleTable" :header-cell-style="setHeaderCellStyle" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" align="center" width="45"> </el-table-column>
              <el-table-column align="center" v-for="(col, index) in columns" :key="index" :label="col.label" :prop="col.prop" :width="col.width" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
          </div>
        </template>
      </List>
    </div>
    <create-invoice-dialog ref="createInvoiceDialogRef" />
    <tip-dialog ref="memberDialog" :show-cancel="false" :dialogOptions="options"></tip-dialog>
  </div>
</template>

<script>
import List from '@components/list/listFrame'
import moment from 'moment'
import invoice from '@api/invoice'
import CreateInvoiceDialog from '@components/personalPage/components/CreateInvoiceDialog'
import TipDialog from '@components/common/TipDialog.vue'

export default {
  name: 'InvoiceList',
  data() {
    return {
      totalCount: 0,
      currentPageNo: 1,
      tableData: [],
      amount: 0,
      columns: [
        {
          prop: 'worksName',
          label: '订阅内容'
        },
        {
          prop: 'orderAmount',
          label: '金额'
        },
        {
          prop: 'createTime',
          label: '订阅日期'
        },
        {
          prop: 'publishUnit',
          label: '出版单位'
        }
      ],
      isAll: false,
      ids: ''
    }
  },
  created() {
    this.getData()
  },
  computed: {
    options() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '开票规则',
        // 弹框内容
        tip: `开票进度、发送方式请联系出版单位，申请开票后，可在"查看开票进度"中查看出版单位联系方式。`
      }
    },
    isMobile() {
      return this.$store.state.book.isMobile
    }
  },
  components: {
    List,
    CreateInvoiceDialog,
    TipDialog
  },
  methods: {
    back() {
      this.$parent.showInvoiceList = false
    },
    submit() {
      this.$refs.createInvoiceDialogRef.open(this.ids)
    },
    reviewRules() {
      /*this.$confirm('开票进度、发送方式请联系出版单位，申请开票后，可在"查看开票进度"中查看出版单位联系方式。', '开票规则', {
        confirmButtonText: '确定'
      })*/
      this.$refs.memberDialog.visible = true
    },
    flipPage(pageNo) {
      this.currentPageNo = pageNo
      this.getData()
    },
    handleSelectionChange(val) {
      this.ids = val.map((_) => _.id).join()
      let a = 0
      a = val.reduce((prev, curr) => {
        return prev + curr.orderAmount
      }, 0)
      this.amount = a
    },
    setHeaderCellStyle() {
      return { 'background-color': '#F7F7F7 ', color: '#333' }
    },
    toggleSelection() {
      this.isAll = !this.isAll
      if (this.isAll) {
        this.tableData.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    getData() {
      let params = {
        pageNo: this.currentPageNo,
        pageSize: 10
      }
      invoice.findSubscribeRecordOrderByPage(params).then((res) => {
        let { status, data } = res.data
        if (status == 0) {
          this.tableData = data.page.result
          /*this.tableData = [
            {
              creator: '18203190952', // 创建书刊的用户
              subscriber: '18937196209', // 下单用户
              worksName: '高中朝鲜语文必修第3册.加水印', //  订阅内容
              subscribeId: 18,
              publishUnit: '方正出版', // 出版单位
              orderAmount: 0.08, // 订单金额
              worksId: 1604,
              createTime: 1684230481000, //  订阅日期
              worksType: 'cloud_read_ebook',
              startTime: 1684230481000,
              orderCode: '202305160000132280',
              id: 12,
              endTime: 2630915281000,
              applyStauts: 0
            },
            {
              creator: '18203190952', // 创建书刊的用户
              subscriber: '18937196209', // 下单用户
              worksName: '高中朝鲜语文必修第3册.加水印', //  订阅内容
              subscribeId: 18,
              publishUnit: '方正出版', // 出版单位
              orderAmount: 0.01, // 订单金额
              worksId: 1604,
              createTime: 1684230481000, //  订阅日期
              worksType: 'cloud_read_ebook',
              startTime: 1684230481000,
              orderCode: '202305160000132280',
              id: 12,
              endTime: 2630915281000,
              applyStauts: 0
            }
          ]*/
          this.tableData.forEach((_) => {
            _.createTime = moment(_.createTime).format('YY-MM-DD HH:mm:ss')
          })
          this.totalCount = data.page.totalCount
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.invoice-list {
  padding-right: 30px;
  font-size: 14px;
  &__title {
    .breadcrumb {
      display: inline-block;
      margin-bottom: 10px;
      .title {
        font-size: 17px;
        font-weight: bold;
      }
      .gray {
        color: #515151;
      }
      .main-color {
        display: inline-block;
        width: 40px;
        text-align: center;
      }
    }
    span.back {
      float: right;
    }
    .btn {
      display: inline-block;
      width: 120px;
      height: 30px;
      font-weight: 500;
      color: #ffffff;
      line-height: 30px;
      background-color: #df5813;
      border-radius: 6px;
      text-align: center;
      cursor: pointer;
      margin-left: 20px;
    }
  }

  &__content {
    margin-top: 20px;
  }

  /deep/.common-list-wrapper .page-component {
    margin-top: -45px;
  }
}
</style>
